const TOKEN_FORMATTER = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

const INTEGER_FORMATTER = new Intl.NumberFormat("en-US");

export function formatTokens(value: number): string {
  return TOKEN_FORMATTER.format(value);
}

export function formatInt(value: number): string {
  return INTEGER_FORMATTER.format(value);
}

export function getModelLabel(
  providerId: string,
  modelId: string,
  modelName: string | null,
): string {
  return modelName || `${providerId}/${modelId}`;
}

/** Format "2026-01-30" -> "Jan 30" */
export function formatDayLabel(day: string): string {
  const d = new Date(day + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

/** Format milliseconds to human-readable duration */
export function formatDuration(ms: number): string {
  if (ms < 1000) return `${Math.round(ms)}ms`;
  const seconds = ms / 1000;
  if (seconds < 60) return `${seconds.toFixed(1)}s`;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds % 60);
  return `${minutes}m ${remainingSeconds}s`;
}

// ---------------------------------------------------------------------------
// Source colors (distinct per-source for the stacked bar)
// ---------------------------------------------------------------------------

export const SOURCE_COLORS: Record<string, { bar: string; label: string }> = {
  slack: { bar: "rgb(var(--cyber-cyan))", label: "text-cyber-cyan" },
  web: { bar: "rgb(var(--cyber-magenta))", label: "text-cyber-magenta" },
  linear: { bar: "rgb(var(--cyber-green))", label: "text-cyber-green" },
};

export function getSourceColor(source: string): { bar: string; label: string } {
  return SOURCE_COLORS[source] ?? { bar: "rgb(var(--cyber-muted))", label: "text-cyber-muted" };
}

// ---------------------------------------------------------------------------
// Token type colors for the advanced breakdown view
// ---------------------------------------------------------------------------

export const TOKEN_TYPE_COLORS = {
  output: { bar: "rgb(var(--cyber-cyan))", label: "text-cyber-cyan", name: "Output" },
  cacheRead: {
    bar: "rgb(var(--cyber-yellow))",
    label: "text-cyber-yellow",
    name: "Cache Read",
  },
  cacheWrite: {
    bar: "rgb(var(--cyber-magenta))",
    label: "text-cyber-magenta",
    name: "Cache Write",
  },
  input: {
    bar: "rgb(var(--cyber-muted))",
    label: "text-cyber-muted",
    name: "Base Input",
  },
  reasoning: {
    bar: "rgb(var(--cyber-green))",
    label: "text-cyber-green",
    name: "Reasoning",
  },
} as const;
